import type { DdocVerifyRequest, ManualDdocsUploadPayload } from 'share/types/api/ddocs'

import { api } from '.'

export const ddocsApi = api.injectEndpoints({
  endpoints: build => ({
    startDdocs: build.query<void, string>({
      query: uuid => ({
        url: `/ddocs/${uuid}/start-ddocs/`,
        method: 'post'
      })
    }),
    ddocsVerify: build.mutation<void, DdocVerifyRequest>({
      query: ({ step_uuid, code }) => ({
        url: `/ddocs/${step_uuid}/ddocs-verify/`,
        method: 'post',
        body: { code }
      })
    }),
    ddocsResendOtp: build.mutation<void, DdocVerifyRequest>({
      query: ({ step_uuid }) => ({
        url: `/ddocs/${step_uuid}/ddocs-resend-otp/`,
        method: 'post'
      })
    }),
    manualDdocsUpload: build.mutation<void, ManualDdocsUploadPayload>({
      query: ({ step_uuid, body }) => ({
        url: `/ddocs/${step_uuid}/upload_ddocs/`,
        method: 'post',
        body
      })
    })
  })
})

export const {
  useStartDdocsQuery,
  useLazyStartDdocsQuery,
  useDdocsVerifyMutation,
  useDdocsResendOtpMutation,
  useManualDdocsUploadMutation
} = ddocsApi
